export default __webpack_public_path__ + "static/media/bihorel9.bd3bd51a.jpg";